import { Banner, BodyText, Heading } from '@postscript/components';
import classes from 'components/ProgressiveOnboarding/MigrationPreparation.module.css';
import { useLocalStorage } from 'hooks/useLocalStorage';

const DISMISSED_BANNER_KEY = 'migration-preparation-dismissed';

export const MigrationPreparation = () => {
  const hasDismissedBanner = useLocalStorage<boolean>({
    key: DISMISSED_BANNER_KEY,
    returnNull: false,
  });

  return (
    <>
      <div className={classes.migrationPreparation}>
        <Heading size="xx-small">Migration Preparation</Heading>
        <BodyText>
          Your onboarding specialist will set up key features for your
          Postscript migration. Review what they&apos;ve configured for you.
        </BodyText>
      </div>
      {!hasDismissedBanner && (
        <Banner
          bodyText={
            <BodyText>
              IMPORTANT: Do not activate Automations, Campaigns, and Popups or
              import your subscribers until Migration Day to prevent duplicate
              messaging.
            </BodyText>
          }
          onDismiss={() => localStorage.setItem(DISMISSED_BANNER_KEY, 'true')}
          variant="warning"
        />
      )}
    </>
  );
};
